<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <x-y-chart
        v-for="data in dataList"
        :key="data.id"
        :data-config="data"
        :unit-prop="unitProp"
        :chart-type="chartType"
        :stack-type="stackType"
        :download-name="downloadName"
        chart-min-height="400px"
        chart-height="auto"
        selected-change-with-data-changed
        style="flex:1 0 100%;"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import DataFormatter from '../../../../model/DataFormatter'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import XYChart from '../../../../components/DataChart/XYChart'

export default {
  name: 'StatisticalAnalysisPM25Ion',
  routeInfo: {
    label: 'PM2.5与离子组分',
    icon: 'fa fa-eye'
  },
  extends: BaseSiteFactorData,
  components: {LayoutContent, DataTimeQuery, SiteQuery, CompletedQuery, DataWrapper, XYChart},
  data: () => ({
    query: {
      factorIds: [],
      isMultipleIntegral: true
    },
    chartType: 'bar',
    stackType: 1
  }),
  computed: {
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, true, siteDeviceFactors => siteDeviceFactors.filter(siteDeviceFactor => siteDeviceFactor.factorId === '1008')),
        new DeviceCategoryConfig(process.env.ION_DEVICE_CATEGORY, true, siteDeviceFactors => siteDeviceFactors.filter(siteDeviceFactor => /_P/i.test(siteDeviceFactor.name)))
      ]
    },
    downloadName: () => ''
  },
  methods: {
    getSeriesParam (dimension, dimensionIds) {
      let factorId = dimensionIds[dimension ^ 1]

      if (factorId === '1008') {
        return {
          type: 'line',
          showSymbol: false
        }
      } else {
        let siteId = dimensionIds[dimension]
        let param = {
          type: 'bar',
          stack: siteId,
          barMaxWidth: 30,
          showSymbol: false,
          areaStyle: {}
        }

        return param
      }
    },
    dataFormatter: DataFormatter.format2,
    formatData () {
      this.dataFormatter()
      let data = {
        id: 'PM25-ION',
        name: 'PM2.5与离子组分',
        dataTimes: this.totalDataTimes,
        ...this.dataList.reduce((data, dataConfig) => {
          let {id, name, dimensions, seriesMap} = dataConfig
          let dimensionsLen = dimensions.length
          let {dimensions: newDimensions, seriesMap: newSeriesMap} = data

          for (let i = 0; i < dimensionsLen; i++) {
            let dimension = dimensions[i]
            let dimensionId = dimension.id
            let newId = `${id}-${dimensionId}`

            newDimensions.push({
              ...dimension,
              id: newId,
              name: `${name}-${dimension.name}`
            })

            newSeriesMap[newId] = seriesMap[dimensionId]
          }

          return data
        }, {
          dimensions: [],
          seriesMap: {}
        })
      }

      this.dataList = Object.freeze([data])
    }
  },
  created () {

  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/00PM/02PM25-Ion/index.vue